export const DEFAULT_PRICING = {
  basic: {
    order: 0,
    name: 'Free',
    price: 'Free',
    priceNote: 'Always free. No credit card.',
    highlight: false,
    badge: '',
    features: [
      '5 AI receipt scans / month',
      'Up to 3 expense reports',
      '50 expenses per report',
      'CSV export',
      'Cloud sync across devices',
      'Multi-currency support',
    ],
    missing: [
      'Excel & Word export',
      'Report sharing',
      'Custom categories',
      'Tax Report',
    ],
  },
  starter: {
    order: 1,
    name: 'Standard',
    price: '$2.99',
    priceNote: 'per month',
    highlight: true,
    badge: 'Most Popular',
    features: [
      '30 AI receipt scans / month',
      '20 expense reports',
      'Unlimited expenses per report',
      'CSV, Excel & JSON export',
      'Combine multiple reports on export',
      'Share reports (view access)',
      'Custom categories',
      'Group & filter expenses',
    ],
    missing: [
      'Word & Tax Report export',
      'Edit-access sharing',
      'Audit trail',
    ],
  },
  pro: {
    order: 2,
    name: 'Pro',
    price: '$6.99',
    priceNote: 'per month',
    highlight: false,
    badge: '',
    features: [
      '150 AI receipt scans / month',
      'Unlimited reports & expenses',
      'All export formats',
      'Tax Report (IRS Schedule C)',
      'Share with edit access',
      'Up to 10 collaborators',
      'Audit trail on all changes',
      'Priority support',
    ],
    missing: [],
  },
};

export const PLAN_KEYS = ['basic', 'starter', 'pro'];
